const NewsItem = ({ type, title, children }) => {
    return (
        <div>
            <article className="flex gap-3">
                <h3 className="bg-sky-800 w-1/6 py-4 px-10 text-slate-50 font-bold text-xl rounded-l-[45px] h-fit ">{type}</h3>
                <div className="w-5/6">
                    <h5 className="font-bold mb-1">{title}</h5>
                    <p className="text-sm text-gray-600">{children}</p>
                </div>
            </article>
        </div>
    );
};

export default NewsItem;
